import { IAuditEventData, MediaUploadsReportAccessAuditSnapshotV1 } from 'api'
import { Box } from 'cs-kevlar-react'
import React from 'react'
import { serverDateToLocaleDateTimeString } from 'utils/dates'
import { DetailField } from './DetailField'
import { UnavailableDetails } from './UnavailableDetails'
import { useDetailStyles } from './useDetailStyles'
import { resolveEventData, resolveSnapshots } from './utils'

interface ReportAccessDetailsProps {
  eventData: IAuditEventData
}

export const ReportAccessDetails: React.FunctionComponent<ReportAccessDetailsProps> = ({
  eventData,
}) => {
  const mediaUploadsInfo = resolveEventData<
    MediaUploadsReportAccessAuditSnapshotV1
  >(eventData, nameof<MediaUploadsReportAccessAuditSnapshotV1>())

  if (!mediaUploadsInfo) return <UnavailableDetails />

  const classes = useDetailStyles()

  return (
    <React.Fragment>
      <Box className={classes.fieldsContainer}>
        <DetailField
          label="Begin Date"
          original={serverDateToLocaleDateTimeString(
            mediaUploadsInfo?.beginDate,
          )}
        />

        <DetailField
          label="End Date"
          original={serverDateToLocaleDateTimeString(mediaUploadsInfo?.endDate)}
        />
      </Box>
    </React.Fragment>
  )
}
